import { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Button, Icon, Input, Tab, Table } from 'semantic-ui-react';

const messages = defineMessages({
  german: {
    id: 'German',
    defaultMessage: 'German',
  },
  english: {
    id: 'English',
    defaultMessage: 'English',
  },
  search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  copy: {
    id: 'Copy',
    defaultMessage: 'Copy',
  },
});

async function copyTextToClipboard(text) {
  if ('clipboard' in navigator) {
    return await navigator.clipboard.writeText(text);
  } else {
    return document.execCommand('copy', true, text);
  }
}

const EntriesTable = ({ entries, keysToDisplay, intl }) => {
  return (
    <Tab.Pane>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              {intl.formatMessage(messages.german)}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {intl.formatMessage(messages.english)}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {keysToDisplay.map((key) => (
          <Table.Row className="selectable">
            <Table.Cell>{key}</Table.Cell>
            <Table.Cell>
              {entries[key]}
              <Button
                basic
                icon
                onClick={() => {
                  copyTextToClipboard(entries[key]);
                }}
                title={intl.formatMessage(messages.copy)}
                size="mini"
                floated="right"
              >
                <Icon name="copy" />
              </Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table>
    </Tab.Pane>
  );
};

const View = ({ content }) => {
  const [entries, setEntries] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  const intl = useIntl();

  useEffect(() => {
    if (entries === false)
      fetch('https://www.uni-koblenz.de/++api++/@translation-glossary')
        .then((data) => data.json())
        .then((data) => {
          setEntries(data.entries || []);
        });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  let panes = [];
  let searchResultsKeys = [];

  if (searchInput.length > 0) {
    /* search: display results without any tabs */
    searchResultsKeys = Object.keys(entries).filter(
      (key) =>
        key.toLowerCase().indexOf(searchInput.toLowerCase()) > -1 ||
        entries[key].toLowerCase().indexOf(searchInput.toLowerCase()) > -1,
    );
  } else {
    /* no search: display tabs for each letter */
    for (let i = 0; i < 26; i++) {
      const letter = String.fromCharCode(65 + i);
      const letterKeys = Object.keys(entries).filter((key) =>
        key.toUpperCase().startsWith(letter),
      );
      if (letterKeys.length > 0) {
        panes.push({
          id: i,
          menuItem: letter,
          pane: (
            <Tab.Pane>
              <EntriesTable
                entries={entries}
                keysToDisplay={letterKeys}
                intl={intl}
              />
            </Tab.Pane>
          ),
        });
      }
    }
  }

  return (
    <div class="deepl-glossary-block">
      <Input
        /* eslint-disable-next-line jsx-a11y/no-autofocus */
        autoFocus
        fluid
        placeholder={intl.formatMessage(messages.search)}
        value={searchInput}
        onChange={(event) => {
          setSearchInput(event.target.value);
        }}
        style={{ marginBottom: '12px' }}
      />
      {searchInput.length > 0 ? (
        searchResultsKeys.length > 0 ? (
          <EntriesTable
            entries={entries}
            keysToDisplay={searchResultsKeys}
            intl={intl}
          />
        ) : (
          <div>
            <br />
            <FormattedMessage
              id="No results found."
              defaultMessage="No results found."
            />
          </div>
        )
      ) : (
        <Tab
          className="tabs-block"
          menu={{ secondary: true, pointing: true }}
          panes={panes}
          renderActiveOnly={false}
        />
      )}
    </div>
  );
};

export default View;
